var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// @ts-ignore
import { fetchConsultar, fetchConsultarPaginada, fetchCadastrar, fetchAlterar, fetchDeletar, URL_API, } from '../../../api';
import { getTokenFromCookie } from '../../../services/mt_login';
export { STATUS_API } from '../../../api';
var buildQueryParams = function (textoBusca, situacao, atendente, dataInicio, dataFim) {
    var query = '';
    if (textoBusca)
        query += "query=".concat(encodeURIComponent(textoBusca), "&");
    if (situacao)
        query += "situacao=".concat(encodeURIComponent(situacao), "&");
    if (atendente)
        query += "atendente_id=".concat(atendente, "&");
    if (dataInicio)
        query += "data_inicio=".concat(encodeURIComponent(dataInicio), "&");
    if (dataFim)
        query += "data_fim=".concat(encodeURIComponent(dataFim), "&");
    return query;
};
var downloadArquivoAtendimentos = function (endpoint, rotaBase, mimeType, textoBusca, situacao, atendente, dataInicio, dataFim) { return __awaiter(void 0, void 0, void 0, function () {
    var query, token, response, blob, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                query = buildQueryParams(textoBusca, situacao, atendente, dataInicio, dataFim);
                token = getTokenFromCookie();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch("".concat(URL_API, "/").concat(rotaBase, "/").concat(endpoint, "/?").concat(query), {
                        method: 'GET',
                        headers: {
                            Authorization: "Bearer ".concat(token),
                            'Content-Type': mimeType,
                        },
                    })];
            case 2:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Failed to fetch ".concat(endpoint.toUpperCase()));
                }
                return [4 /*yield*/, response.blob()];
            case 3:
                blob = _a.sent();
                return [2 /*return*/, window.URL.createObjectURL(blob)];
            case 4:
                error_1 = _a.sent();
                console.error("Erro ao gerar o ".concat(endpoint.toUpperCase(), ":"), error_1);
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var criarAtendimentoService = function (rotaBase) {
    return {
        cadastrarAtendimento: function (dados) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchCadastrar(rotaBase, dados)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getAtendimentos: function (textoBusca, situacao, atendente, dataInicio, dataFim, paginationModel) { return __awaiter(void 0, void 0, void 0, function () {
            var query;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = buildQueryParams(textoBusca, situacao, atendente, dataInicio, dataFim);
                        return [4 /*yield*/, fetchConsultarPaginada("".concat(rotaBase, "/?").concat(query), paginationModel)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getAtendimento: function (atendimentoId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchConsultar("".concat(rotaBase, "/").concat(atendimentoId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getReeducando: function (reeducandoId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchConsultar("".concat(rotaBase, "/reeducando/").concat(reeducandoId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getCombosListar: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchConsultar("".concat(rotaBase, "/combos-listar"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        getCombosCadastro: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchConsultar("".concat(rotaBase, "/combos-cadastro"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        alterarAtendimento: function (dados, atendimentoId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchAlterar("".concat(rotaBase, "/").concat(atendimentoId), dados)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        excluirAtendimento: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchDeletar("".concat(rotaBase, "/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        gerarExcelAtendimentos: function (textoBusca, situacao, atendente, dataInicio, dataFim) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, downloadArquivoAtendimentos('excel', rotaBase, 'application/vnd-xls', textoBusca, situacao, atendente, dataInicio, dataFim)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        gerarPDFAtendimentos: function (textoBusca, situacao, atendente, dataInicio, dataFim) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, downloadArquivoAtendimentos('pdf', rotaBase, 'application/pdf', textoBusca, situacao, atendente, dataInicio, dataFim)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
    };
};
